import * as React from "react";
import { Button, CircularProgress } from "@mui/material";

export default function MuiButton({
  onClick,
  loading = false,
  disabled = false,
  type = "button",
  variant = "contained",
  color = "primary",
  size = "medium",
  children, // Use children to allow custom text or elements
}) {
  return (
    <Button
      onClick={onClick}
      type={type}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading} // Disable the button if it's loading
      startIcon={loading && <CircularProgress size={20} color="inherit" />} // Show loading spinner
    >
      {loading ? "Loading..." : children} {/* Show "Loading..." if loading */}
    </Button>
  );
}
